//import jsreport from "jsreport-browser-client-dist";
import AWS from "aws-sdk";
import _ from "lodash";
//import moment from "moment";

import * as utils from "../utils/utils";
import state from "../state";
import env from "../constants/env";
import config from "../config/config";

//import { refreshCredentials } from "../utils/securityUtil";
import { showError, showSuccess, showError2 } from "../actions/alertActions";
//import { updateSharedDocument } from "../actions/shareActivityActions";
//import { getOrgId } from "../actions/orgsActions";
//import { updateAttribute, getIdentityId, isOrganizationAdministrator, isOrganizationAuthor } from "../actions/user";
import { getIdentityId } from "../actions/user";
//import { putLock } from "../actions/activityActions";
//import { setActivities, updateActivity, initializeInventory, INVENTORY_EXTERNAL_CONTENT_PERSISTENT_PROPS } from "../actions/inventoryActions";
//import { sendInventoryAndUserInfoMessage, postMessage } from "../actions/mobileAppCommunicationActions";
// import PlayerPaths from "../constants/paths/playerPaths"; 

//import timerTemplates from "../data/timerTemplates.json";



AWS.config.update({ region: env.aws.defaultRegion });

export const PUBLIC_KEY_PREFIX = "public";
//const INVENTORY_FILE_NAME = "experiences.json";
//const TIMER_TEMPLATES_FILE_NAME = "timerTemplates.json";

async function refreshCredentials() {
	if (!_.isUndefined(_.get(config, "persistence.refreshCredentials"))) {
		const res = await config.persistence.refreshCredentials();
		// console.log("RefreshCredentials", res);
		AWS.config.credentials = res.awsTempCredentials;
	} else {
		return Promise.resolve();
	}
}

/*
export function promoteChecklist(keyPrefix, srcChecklistId) {
	refreshCredentials().then(() => {
		const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: env.s3.contentBucket, ResponseContentType: "application/json", ResponseCacheControl: "no-cache" } });
		bucket.getObject({ Key: `${keyPrefix}/${srcChecklistId}.json` }, (_err2, data) => {
			if (_err2) {
				alert(_err2, _err2.stack);
			} else {
				const checklist = JSON.parse(data.Body.toString());
				addChecklistForPromote(checklist);
			}
		});
	}).catch((err) => {
		console.error(err);
		showError2("Add failed", err);
	});
}

function addChecklistForPromote(checklist) {
	const baseId = checklist.id;
	checklist.id = utils.generateUUID();
	if (checklist.hasOwnProperty("baseIds")) {
		checklist.baseIds.push(baseId);
	} else {
		const baseIds = [];
		baseIds.push(baseId);
		checklist.baseIds = baseIds;
	}
	// Need to think through all scenarios...for now allow people to delete anything
	checklist.cloned = false;

	const newDocument = {
		id: checklist.id,
		name: checklist.name,
		description: checklist.description,
		cloned: false,
		genre: checklist.genre,
		tags: checklist.tags,
		contributors: checklist.hasOwnProperty("contributors") ? checklist.contributors : [{ name: state.get(["user", "name"]), username: state.get(["user", "username"]), nickname: state.get("user", "nickname") }],
		publisher: checklist.publisher,
		store: "",
		productPlaneId: "",
		shareCode: "",
		shareCodeReceived: "",
		version: "1.0",
		visible: true,
		speedType: "KIAS",
	};

	updateChecklistsAndPushToS3(checklist, newDocument);

	showSuccess("Added", "This activity has been successfuly added to My Activities.");
}

export function getHistory(tree, identityId) {
	refreshCredentials().then(async () => {

		const checklistHistory = [];

		const keyPrefix = utils.getKeyPrefix(identityId);

		const s3 = new AWS.S3({ useDualStack: true });

		const params = {
			Bucket: env.s3.contentBucket,
			Delimiter: "/",
			Prefix: `${keyPrefix}/`,
		};

		const listFoldersData = await s3.listObjects(params).promise();

		const folders = listFoldersData.CommonPrefixes;
		for (let i = 0; i < folders.length; i++) {
			const folder = folders[i];
			// Ignore assets folders
			if (!folder.Prefix.includes("/assets/") && !folder.Prefix.includes("/userAssets/")) {
				params.Prefix = folder.Prefix;

				const checklistId = folder.Prefix.split("/")[1];
				// // console.log("Checklist ID: " + checklistId);

				const checklistHistoryItem = {
					type: "checklistHistory",
					id: checklistId,
					name: "",
					description: "",
					instances: [],
				};

				checklistHistory.push(checklistHistoryItem);

				const filesData = await s3.listObjects(params).promise();

				// // console.log(filesData);
				const files = filesData.Contents;
				for (let j = 0; j < files.length; j++) {
					const file = files[j].Key;

					// Need to get checklist instance using async await
					// // console.log("File: " + file);
					const data = await s3.getObject({ Bucket: env.s3.contentBucket, Key: file }).promise();

					const checklistInstance = JSON.parse(data.Body.toString());
					checklistHistoryItem.name = checklistInstance.name;
					checklistHistoryItem.description = checklistInstance.description;
					checklistHistoryItem.instances.push(checklistInstance);
				}

			}
		}

		tree.set(["checklistHistory"], checklistHistory);
	}).catch((err) => {
		console.error(err);
		showError2("Get History", err);
	});
}

export function touchHistoryFiles(identityId) {
	refreshCredentials().then(async ({ cognitoUser }) => {
		let keyPrefix = utils.getKeyPrefix(identityId);

		let s3 = new AWS.S3({ useDualStack: true });

		let params = {
			Bucket: env.s3.contentBucket,
			Delimiter: "/",
			Prefix: keyPrefix + "/"
		};

		let listFoldersData = await s3.listObjects(params).promise();

		let folders = listFoldersData.CommonPrefixes;
		for (let i = 0; i < folders.length; i++) {
			let folder = folders[i];
			// Ignore assets folders
			if (!folder.Prefix.includes("/assets/") && !folder.Prefix.includes("/userAssets/")) {
				params.Prefix = folder.Prefix;

				let filesData = await s3.listObjects(params).promise();

				let files = filesData.Contents;
				for (let j = 0; j < files.length; j++) {
					let file = files[j].Key;

					// Need to get checklist instance using async await
					//// console.log("File: " + file);
					await s3.copyObject({ MetadataDirective: "REPLACE", CopySource: `${env.s3.contentBucket}/` + file, Bucket: env.s3.contentBucket, Key: file }).promise();
				}

			}
		}

		updateAttribute(cognitoUser, "custom:historyUpdated", "true");
	}).catch((err) => {
		console.error(err);
		showError2("History", err);
	});
}
*/

// With multiple devices a user may overwrite the ${globals.artifacts.inventoryFileName} from one device. This will restore any checklists that are lost.
// function reconstructChecklistsCollection(tree, identityId, checklists) {
// 	refreshCredentials().then(async () => {
// 		const keyPrefix = utils.getKeyPrefix(identityId);

// 		const s3 = new AWS.S3({ useDualStack: true });

// 		const params = {
// 			Bucket: env.s3.contentBucket,
// 			Delimiter: "/",
// 			Prefix: `${keyPrefix}/`,
// 		};

// 		const filesData = await s3.listObjects(params).promise();

// 		const files = filesData.Contents;
// 		// console.log("Files", files);
// 		for (let i = 0; i < files.length; i++) {
// 			const file = files[i].Key.replace(`${keyPrefix}/`, "").replace(".json", "");

// 			if (file !== "user" && file !== "experiences") {
// 				// Check if in checklists array, if not create new object and append
// 				let found = false;
// 				for (let j = 0; j < checklists.length; j++) {
// 					const currentChecklist = checklists[j];
// 					if (file === currentChecklist.id) {
// 						found = true;
// 					}
// 				}

// 				if (!found) {
// 					const data = await s3.getObject({ Bucket: env.s3.contentBucket, Key: `${keyPrefix}/${file}.json` }).promise();

// 					// Reconstruct items need for ${globals.artifacts.inventoryFileName}
// 					const checklist = JSON.parse(data.Body.toString());

// 					const newChecklist = {};
// 					newChecklist.id = checklist.id;
// 					newChecklist.name = checklist.name;
// 					newChecklist.description = checklist.description;
// 					newChecklist.genre = checklist.genre;
// 					newChecklist.tags = checklist.tags;
// 					newChecklist.publisher = checklist.publisher;
// 					newChecklist.store = checklist.store !== null ? checklist.store : "";
// 					newChecklist.productPlaneId = checklist.productPlaneId !== null ? checklist.productPlaneId : "";
// 					newChecklist.shareCode = checklist.shareCode !== null ? checklist.shareCode : "";
// 					newChecklist.shareCodeReceived = checklist.shareCodeReceived !== null ? checklist.shareCodeReceived : "";
// 					newChecklist.version = checklist.version !== null ? checklist.version : "1.0";
// 					newChecklist.cloned = checklist.cloned;
// 					newChecklist.visible = checklist.visible !== null ? checklist.visible : true;
// 					newChecklist.speedType = checklist.speedType;
// 					newChecklist.contributors = checklist.contributors;
// 					// console.log(newChecklist);
// 					checklists.push(newChecklist);
// 				}
// 			}
// 		}

// 		// Write out new ${globals.artifacts.inventoryFileName} to S3
// 		saveJsonToS3(checklists, env.s3.contentBucket, env.artifacts.inventoryFileName, "", false);

// 	}).catch((err) => {
// 		console.error(err);
// 		showError2("Reconstruct Checklists Collection Failed", err);
// 	});
// }

// export function getChecklistsCollection(tree, username, bucket, keyPrefix, jsonDocuments) {
// 	bucket.getObject({ Key: `${keyPrefix}/${env.artifacts.inventoryFileName}` }, (err, data) => {
// 		if (err) {
// 			const putBatch = function putBatch(files) {
// 				return Promise.all(files.map((file) => {
// 					let body;
// 					if (file === env.artifacts.inventoryFileName) {
// 						body = JSON.stringify(jsonDocuments);
// 					}
// 					// console.log("PUT INVENTORY");
// 					return bucket.putObject({ Key: `${keyPrefix}/${file}`, ContentType: "application/json", Body: body }).promise();
// 				}));
// 			};

// 			const files = [env.artifacts.inventoryFileName];

// 			putBatch(files)
// 				.then(() => {
// 					reconstructChecklistsCollection(tree, keyPrefix, jsonDocuments);
// 					// actions.receiveDocuments(jsonDocuments);

// 					if (utils.isMobile()) {
// 						getChecklists(username, keyPrefix, bucket).catch(() => {
// 							utils.hideLoader(tree);
// 						});													

// 						actions.postMessage({ method: "hideModalEditor" });

// 					} else {
// 						navigate(true);
// 					}
// 				})
// 				.catch(() => {
// 					utils.hideLoader(tree);
// 					// console.log("Error putiing batch uploads!");
// 				});
// 		} else {
// 			const checklists = JSON.parse(data.Body.toString());
// 			clearFilters(checklists);
// 			reconstructChecklistsCollection(tree, keyPrefix, checklists);
// 			// actions.receiveDocuments(checklists);

// 			if (utils.isMobile()) {
// 				getChecklists(username, keyPrefix, bucket).catch(() => {
// 					utils.hideLoader(tree);
// 				});	

// 				actions.postMessage({ method: "hideModalEditor" });

// 			} else {
// 				navigate(true);
// 			}
// 		}
// 	});
// }

// export function getChecklists(username, keyPrefix, bucket, nav = true) {	
// 	const originalKeyPrefix = keyPrefix;
// 	const getBatch = function getBatch(checklists) {
// 		return Promise.all(checklists.map((checklist) => {
// 			if (checklist.hasOwnProperty("identityId")) {
// 				keyPrefix = checklist.identityId;
// 			} else {
// 				keyPrefix = originalKeyPrefix;
// 			}
// 			return bucket.getObject({ Key: `${keyPrefix}/${checklist.id}.json` }).promise().then((data) => {
// 				let jsonChecklist = JSON.parse(data.Body.toString());

// 				// Should convert to make sure has at least one list and one section and set proper type
// 				jsonChecklist = utils.normalizeChecklist(jsonChecklist);

// 				jsonChecklist.visible = checklist.visible;
// 				/* TODO with trying to support showing history when shared
// 				if (checklist.hasOwnProperty("initialInstanceId")) {
// 					jsonChecklist.initialInstanceId = checklist.initialInstanceId;
// 				}
// 				*/
// 				// Get speed for checklist from document
// 				if (checklist.hasOwnProperty("speedType")) {
// 					jsonChecklist.speedType = checklist.speedType;
// 					jsonChecklist.preferences.speedType = checklist.speedType;
// 				}

// 				// Find checklist with same key and replace
// 				for (let i = 0; i < newChecklists.checklists.length; i++) {
// 					if (newChecklists.checklists[i].id === jsonChecklist.id) {
// 						newChecklists.checklists[i] = jsonChecklist;
// 					}
// 				}
// 			}).catch((err) => {
// 				// console.log(`Error getting checklist ${checklist.id}; ${err}`);
// 				actions.postMessage({ "method": "error", "message": `Error getting checklist ${checklist.id}; ${err}` });
// 				throw err;
// 			});
// 		}));
// 	};
// 	const user = state.get(["user"]);

// 	// newChecklists is what pass to mobile app. Aggregate users, content and checklists
// 	const newChecklists = {
// 		user: {
// 			username,
// 			scr: state.get(["user","password"]),
// 			savePassword: utils.getLs(state.get(["user","username"]) + ";savePassword"),
// 			rememberMe: utils.getLs(state.get(["user", "username"]) + ";rememberMe"),
// 			identityId: keyPrefix,
// 			subscriptionPlan: user.subscriptionPlan,
// 			subscriptionExpiration: user.hasOwnProperty("subscriptionExpiration") ? user.subscriptionExpiration : 0,
// 			member: state.get(["selectedOrg","member"])
// 		},
// 		checklists: [],
// 	};

// 	// console.log("getChecklists: " + JSON.stringify("user"));

// 	return new Promise((resolve, reject) => {
// 		bucket.getObject({ Key: `${keyPrefix}/${env.artifacts.inventoryFileName}` }, (err, data) => {
// 			if (err) {
// 				// console.log(err, err.stack);
// 				actions.postMessage({ "method": "error", "message": `Error getting artifact inventory: ${err}` });
// 				reject(err);
// 			} else {
// 				const checklists = JSON.parse(data.Body.toString());

// 				newChecklists.checklists = checklists;

// 				getBatch(checklists)
// 					.then(() => {
// 						state.set(["user", "loggedIn"], true);
// 						state.set(["user", "username"], username);

// 						// Need to get content for the app
// 						bucket.getObject({ Key: "apps/ambifi/content/en-US/ambifi-en-US.json" }, (err, data) => {
// 							if (err) {
// 								// console.log(err, err.stack);
// 								actions.postMessage({ "method": "error", "message": `Error getting content: ${err}` });
// 								reject(err);
// 							} else {
// 								const content = JSON.parse(data.Body.toString());
// 								newChecklists.content = content;

// 								// Only want to do if calling from mobile app
// 								injectShares(newChecklists.checklists, true).then((checklists) => {
// 									newChecklists.checklists = checklists;
// 									actions.postMessage(newChecklists);

// 									setTimeout(function () {
// 										actions.navigate(nav);
// 									}, 2000);

// 									resolve("");
// 									// console.log("Get success");
// 								}).catch((err) => {
// 									// console.log(`Error in injectShares: ${err}`);
// 									actions.postMessage({ "method": "error", "message": `Error in injectShares: ${err}` });
// 									reject(err);
// 								});								
// 							}
// 						});

// 					}).catch((err) => {
// 						console.error.bind(console);
// 						// console.log("Error getting batch checklists!");			
// 						actions.postMessage({ "method": "error", "message": `Error in getBatch: ${err}` });
// 						reject(err);
// 						//return false;
// 					});
// 			}
// 		});
// 	});
// }

export function uploadFileToS3(bucket, keyPrefix, file, emptyBody = false, ignoreFileName = false) {
	return new Promise((resolve, reject) => {
		refreshCredentials().then(() => {
			// Instantiate aws sdk service objects now that the credentials have been updated.
			const _bucket = new AWS.S3({ useDualStack: true, params: { Bucket: bucket } });
			const params = { Key: `${keyPrefix}${file && file.name && !ignoreFileName ? `/${utils.fixFileNameForS3(file.name)}` : ""}` };
			if (!emptyBody) {
				params.ContentType = file.type;
				params.Body = file;
			} else {
				params.Body = "Empty";
			}
			_bucket.upload(params, (err) => {
				if (err) {
					reject(err);
				} else {
					resolve();
				}
			});
		}).catch((err) => {
			console.error(err);
			showError2("Failed to obtain session to upload file to S3", err);
			reject(err);
		});
	});

}

/*
export function uploadFilesToS3(bucketName, files) {
	refreshCredentials().then(() => {

		const keyPrefix = `${utils.getKeyPrefix(state.select(["user", "identityId"]).get())}/assets`;

		// Instantiate aws sdk service objects now that the credentials have been updated.
		const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: bucketName } });

		for (let i = 0; i < files.length; i++) {
			const file = files[i];
			if (file) {
				// get file contents in memory
				const reader = new FileReader();
				reader.readAsText(file, "UTF-8");
				reader.onload = (evt) => {
					const csvContent = evt.target.result;

					const event = {
						csvContent,
						name: file.name.split(".")[0],
						checklistId: utils.generateUUID(),
					};

					// console.log(csvContent);
					// invoke lambda to do import
					const lambda = new AWS.Lambda({ region: env.aws.defaultRegion, apiVersion: "2015-03-31" });

					const params = {
						FunctionName: env.lambda.importCsvFunction,
						InvocationType: "RequestResponse",
						LogType: "None",
						Payload: JSON.stringify(event),
					};

					lambda.invoke(params, (error, data) => {
						if (error) {
							alert(error);
						} else {
							// console.log(data.Payload);
							const checklist = JSON.parse(data.Payload);

							checklist.contributors = [{ name: state.get("user", "name"), username: state.get("user", "username"), nickname: state.get("user", "nickname") }];

							// Upload new file
							importChecklistFromCsv(checklist);
						}
					});
				};
				reader.onerror = () => {
					alert("Error reading file");
				};

				const ts = Date.now();

				// Upload to S3 and S3 triggers conversion
				const params = { Key: `${keyPrefix}/${ts}-${file.name}`, ContentType: file.type, Body: file };
				bucket.upload(params, (err) => {
					// Successfully have file on S3
					const result = err ? "ERROR!" : "SAVED.";
					// console.log(result);
				});
			}
		}

	}).catch((err) => {
		console.error(err);
		showError2("Upload file to S3 failed", err);
	});
}
*/

export function waitForKeyExists(Bucket, Key) {
	return new Promise((resolve, reject) => {
		refreshCredentials().then(() => {
			const s3 = new AWS.S3({ useDualStack: true });
			let params = {
				Bucket,
				Key
			};
			s3.waitFor("objectExists", params, (err, data) => {
				if (err) {
					reject(err);
				} else {
					resolve(data);
				}
			});
		});
	});
}

export function uploadMediaFileToS3(bucketName, file, fileName, type) {
	return new Promise((resolve, reject) => {
		refreshCredentials().then(() => {
			const keyPrefix = type;

			// Instantiate aws sdk service objects now that the credentials have been updated.
			const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: bucketName } });

			// var ts = Date.now();

			// Upload to S3 and S3 triggers conversion
			const params = { Key: `${keyPrefix}/${fileName}`, ContentType: file.type, Body: file };

			bucket.upload(params, (err) => {
				// Successfully have file on S3
				if (err) {
					reject(err);
				} else {
					resolve();
				}
			});

		}).catch((err) => {
			reject(err);
		});
	});
}

/*
export function logToCloudWatch(logData) {
	refreshCredentials().then(() => {
		const event = {
			logData,
		};

		// invoke lambda to do import
		const lambda = new AWS.Lambda({ region: env.aws.defaultRegion, apiVersion: "2015-03-31" });

		const params = {
			FunctionName: "logToCloudWatch",
			InvocationType: "RequestResponse",
			LogType: "None",
			Payload: JSON.stringify(event),
		};

		lambda.invoke(params, (error, data) => {
			if (error) {
				alert(error);
			} else {
				alert(data.Payload);
			}
		});
	}).catch((err) => {
		console.error(err);
		showError2("logToCloudWatch", err);
	});
}

// Getting image data directly from S3
// Our new approach uses Cloudfront to get the image
export function showImage() {
	refreshCredentials().then(() => {
		const keyPrefix = utils.getKeyPrefix(state.select(["user", "identityId"]).get());

		const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: "assets.pricer.miralouaero.com" } });

		bucket.getObject({ Key: `${keyPrefix}/DSCN0008.JPG` }, (err) => {
			if (err) {
				// console.log(err, err.stack);
			}
		});

	}).catch((err) => {
		console.error(err);
		showError2("Error in show image", err);
	});
}

// TODO: Complete one-off...can reuse function above if make async/await
export function previewJsonFromS3(tree, bucketName, fileName, scope) {
	refreshCredentials().then(() => {
		const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: bucketName, ResponseContentType: "application/json", ResponseCacheControl: "no-cache" } });

		const Key = scope === "learning" ? `${env.s3.ambiFiLearningKey}/${fileName}` : scope === "public" ? `${PUBLIC_KEY_PREFIX}/${fileName}` : `${getOrgId()}/${PUBLIC_KEY_PREFIX}/${fileName}`;

		bucket.getObject({ Key }, (err, data) => {
			if (err) {
				showError("Unable to get checklist", err);
			} else {
				// Set previewChecklist
				let jsonChecklist = JSON.parse(data.Body.toString());
				// Should convert to make sure has at least one list and one section and set proper type
				jsonChecklist = utils.normalizeActivity(jsonChecklist);

				tree.set(["appState", "previewChecklist", "checklist"], jsonChecklist);
				tree.set(["appState", "previewChecklist", "showModal"], true);
			}
		});

	}).catch((err) => {
		console.error(err);
		showError2("Preview failed", err);
	});
}

export function previewJsonForIdentityFromS3(tree, bucketName, identityId, fileName) {
	refreshCredentials().then(() => {
		const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: bucketName, ResponseContentType: "application/json", ResponseCacheControl: "no-cache" } });

		const Key = `${identityId}/${fileName}`;

		bucket.getObject({ Key }, (err, data) => {
			if (err) {
				showError("Unable to get checklist", err);
			} else {
				// Set previewChecklist
				let jsonChecklist = JSON.parse(data.Body.toString());
				// Should convert to make sure has at least one list and one section and set proper type
				jsonChecklist = utils.normalizeActivity(jsonChecklist);

				tree.set(["appState", "previewChecklist", "checklist"], jsonChecklist);
				tree.set(["appState", "previewChecklist", "showModal"], true);
			}
		});

	}).catch((err) => {
		console.error(err);
		showError2("Preview failed", err);
	});
}

export function showNotes(tree, bucketName, fileName) {
	refreshCredentials().then(() => {
		const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: bucketName, ResponseContentType: "application/json", ResponseCacheControl: "no-cache" } });
		bucket.getObject({ Key: `${fileName}` }, (err, data) => {
			if (err) {
				showError("Unable to get checklist", err);
			} else {
				// Set previewChecklist
				let jsonChecklist = JSON.parse(data.Body.toString());
				// Should convert to make sure has at least one list and one section and set proper type
				jsonChecklist = utils.normalizeActivity(jsonChecklist);

				tree.set(["appState", "showNotes", "checklist"], jsonChecklist);
				tree.set(["appState", "showNotes", "showModal"], true);
			}
		});
	}).catch((err) => {
		console.error(err);
		showError2("Preview failed", err);
	});
}

export function showDetailedStatus(tree, bucketName, fileName, allowEdit = true) {
	refreshCredentials().then(() => {
		loadActivityInstanceFromS3(bucketName, fileName).then((result) => {
			tree.set(PlayerPaths.CHECKLIST, result);
			tree.set(PlayerPaths.CHECKLIST_IDENTITY_ID, fileName.substring(0, fileName.indexOf("/")));
			tree.set(["appState", "showDetailedStatus", "showModal"], true);
			tree.set(["appState", "showDetailedStatus", "edit"], false);
			tree.set(["appState", "showDetailedStatus", "allowEdit"], allowEdit);
		}).catch((err) => {
			console.error(err);
			showError2("Load activity failed", err);
		});
	}).catch((err) => {
		console.error(err);
		showError2("Preview failed", err);
	});
}

export function showDetailedHistory(tree, bucketName, fileName) {
	refreshCredentials().then(() => {
		const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: bucketName, ResponseContentType: "application/json", ResponseCacheControl: "no-cache" } });
		bucket.getObject({ Key: `${fileName}` }, (err, data) => {
			if (err) {
				showError("Unable to get checklist", err);
			} else {
				// Set previewChecklist
				let jsonChecklist = JSON.parse(data.Body.toString());
				// Should convert to make sure has at least one list and one section and set proper type
				jsonChecklist = utils.normalizeActivity(jsonChecklist);

				tree.set(["appState", "showDetailedHistory", "checklist"], jsonChecklist);
				tree.set(["appState", "showDetailedHistory", "showModal"], true);
			}
		});
	}).catch((err) => {
		console.error(err);
		showError2("Preview failed", err);
	});
}


export function printInstance(tree, bucketName, fileName) {
	refreshCredentials().then(() => {
		const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: bucketName, ResponseContentType: "application/json", ResponseCacheControl: "no-cache" } });
		bucket.getObject({ Key: `${fileName}` }, (err, data) => {
			if (err) {
				showError("Unable to get checklist", err);
			} else {
				// Set previewChecklist
				let jsonChecklist = JSON.parse(data.Body.toString());
				// Should convert to make sure has at least one list and one section and set proper type
				jsonChecklist = utils.normalizeActivity(jsonChecklist);

				utils.recurseReplaceSpeeds(jsonChecklist.children);
				utils.recurseConvertChecklistToMarkdown(jsonChecklist.children, false);

				let printFilename = "";
				let lastUpdated = "";
				if (jsonChecklist.history.length > 0) {
					lastUpdated = jsonChecklist.history[jsonChecklist.history.length - 1].timestamp;
				}

				if (lastUpdated !== "") {
					printFilename = jsonChecklist.name + " - " + lastUpdated;

				} else {
					printFilename = jsonChecklist.name;
				}

				printTemplate(printFilename, jsonChecklist, "ambifi-lists-form-no-media");
			}
		});
	}).catch((err) => {
		console.error(err);
		showError2("Print Instance failed", err);
	});
}

// export function getAllChecklists(tree) {
// 	return refreshCredentials().then(({ cognitoUser }) => {
// 		const keyPrefix = utils.getKeyPrefix(state.select(["user", "identityId"]).get());

// 		const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: env.s3.contentBucket, ResponseContentType: "application/json" , ResponseCacheControl: "no-cache" } });

// 		return getChecklists(cognitoUser.getUsername(), keyPrefix, bucket, false).then(() => {
// 			utils.hideLoader(tree);
// 		}).catch((err) => {
// 			actions.postMessage({ "method": "error", "message": `Error in call to getChecklists: ${err}` });
// 			utils.hideLoader(tree);
// 			throw err;
// 		});

// 	}).catch((err) => {
// 		console.error(err);
// 		utils.hideLoader(tree);
// 		showError2("Get checklists failed", err);

// 		actions.postMessage({ "method": "error", "message": `Error in getAllChecklists; ${err}` });
// 		throw err;
// 	});
// }

export function saveJsonToS3WithKeyPrefix(object, bucketName, keyPrefix, fileName, message = "") {
	refreshCredentials().then(() => {
		// Instantiate aws sdk service objects now that the credentials have been updated.
		const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: bucketName } });
		const params = { Key: `${keyPrefix}/${fileName}`, ContentType: "application/json", Body: JSON.stringify(object) };
		bucket.upload(params, (err) => {
			const result = err ? "ERROR!" : "SAVED.";
			// console.log(result);
			// Replace with notification
			if (!err) {
				if (message !== "") {
					showSuccess("Successfully saved", message);
				}
			} else {
				showError("Failed to save", err.message);
			}
		});

	}).catch((err) => {
		console.error(err);
		showError2("Save failed", err);
	});
}
*/

export function saveHistory(bucketName, files, keyPrefixOverride = "", refreshChecklists = false) {
	return new Promise(async (resolve, reject) => {
		let keyPrefix = keyPrefixOverride;
		if (keyPrefix === "") {
			keyPrefix = utils.getKeyPrefix(state.select(["user", "identityId"]).get());
		}
		try {
			await refreshCredentials();
			const result = await putBatch(bucketName, keyPrefix, files);
			resolve(result);
		} catch (e) {
			console.error(e);
			reject(e);
		}
	});
}


// Need to send in batch instead of loop
export function saveJsonToS3ForHistory(object, bucketName, fileName) {
	refreshCredentials().then(() => {
		const keyPrefix = utils.getKeyPrefix(state.select(["user", "identityId"]).get());

		// Instantiate aws sdk service objects now that the credentials have been updated.
		const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: bucketName } });
		const params = { Key: `${keyPrefix}/${fileName}`, ContentType: "application/json", Body: JSON.stringify(object) };
		// console.log(`SAVE HISTORY: ${keyPrefix}/${fileName}`);
		bucket.upload(params, (err) => {
			// const result = err ? "ERROR!" : "SAVED.";
			// console.log(result);
			// Replace with notification
			if (err) {
				showError("History save failed", err.message);
			}
		});
	}).catch((err) => {
		console.error(err);
		showErrorNoDetail("Save history failed", err);
	});
}

export function saveJsonToS3(object, bucketName, fileName, message = "", getChecklists = true) {
	return new Promise((resolve, reject) => {
		refreshCredentials().then(() => {
			const keyPrefix = utils.getKeyPrefix(state.select(["user", "identityId"]).get());

			// Instantiate aws sdk service objects now that the credentials have been updated.
			uploadObject(object, bucketName, keyPrefix).then(() => {
				// If getChecklists then refresh content on mobile device
				/*
				if (getChecklists) {
					sendInventoryAndUserInfoMessage().then(() => {
						if (message !== "") {
							showSuccess("Save successful", message);
							state.set(["appState", "editor", "showSpinner"], false);
						}
					}).catch(err => {
						showError("Failed to save", err.message);
						reject(err);
					});

					// receiveDocuments sets the state in the app
				} else {
					console.debug("In saveJsonToS3", object);
					initializeInventory(false).catch(err => {
						showError("Failed to save", err.message);
						reject(err);
					});
				}
				*/
			}).catch(err => {
				showError("Failed to save", err.message);
				reject(err);
			});
		}).catch((err) => {
			console.error(err);
			showError2("Save failed", err);
			reject(err);
		});
	});
}

export function getJsonFileFromS3(bucketName, fileName) {
	return new Promise((resolve, reject) => {
		refreshCredentials().then(async () => {
			const keyPrefix = utils.getKeyPrefix(state.get(["user", "identityId"]));

			const s3 = new AWS.S3({ useDualStack: true });

			try {
				const data = await s3.getObject({ Bucket: bucketName, Key: keyPrefix + "/" + fileName }).promise();

				// console.log("GET!: " + data.Body.toString());

				resolve(JSON.parse(data.Body.toString()));

			} catch (err) {
				reject("Error: " + err.message);
			}
		}).catch((err) => {
			console.error(err);
			showError2("Save failed", err);
			reject(err);
		});
	});
}

export function putJsonFileToS3(bucketName, fileName, data) {
	return new Promise((resolve, reject) => {
		refreshCredentials().then(async () => {
			const body = JSON.stringify(data);
			const keyPrefix = utils.getKeyPrefix(state.get(["user", "identityId"]));
			const s3 = new AWS.S3({ useDualStack: true });

			try {
				await s3.putObject({ Bucket: bucketName, Key: keyPrefix + "/" + fileName, Body: body }).promise();

				// console.log("PUT!: " + data);
				resolve(data);
			} catch (err) {
				reject("Error: " + err.message);
			}
		}).catch((err) => {
			console.error(err);
			showError2("Save failed", err);
			reject(err);
		});
	});
}

export function deleteJsonFileFromS3WithKeyPrefix(bucketName, keyPrefix, fileName) {
	return deleteObject(bucketName, `${keyPrefix}/${fileName}`).catch((err) => {
		console.error(err);
		showError2("Delete failed", err);
	});
}

export function deleteJsonFileFromS3(bucketName, fileName) {
	const keyPrefix = utils.getKeyPrefix(state.select(["user", "identityId"]).get());
	const key = `${keyPrefix}/${fileName}`;

	return deleteObject(bucketName, key).catch((err) => {
		console.error(err);
		showError2("Delete failed", err);
	});
}

export function saveJsonFilesToS3WithKeyPrefix(bucketName, files, message = "") {
	refreshCredentials().then(() => {
		putBatchWithKeyPrefix(bucketName, files)
			.then(() => {
				if (message !== "") {
					showSuccess("Save successful", message);
					state.set(["appState", "editor", "showSpinner"], false);
				}
			}).catch(err => {
				throw err;
			});
	}).catch((err) => {
		console.error(err);
		showError2("Save failed", err);
	});
}

// This also getAllChecklists
export function saveJsonFilesToS3(bucketName, files, message = "", getChecklists = true) {
	return new Promise((resolve, reject) => {
		refreshCredentials().then(() => {
			const keyPrefix = utils.getKeyPrefix(state.select(["user", "identityId"]).get());
			putBatch(bucketName, keyPrefix, files)
				.then(() => {
					/*
					if (getChecklists) {
						sendInventoryAndUserInfoMessage().then(() => {
							if (message !== "") {
								showSuccess("Save successful", message);
								state.set(["appState", "editor", "showSpinner"], false);
							}
							resolve();
						}).catch(err => {
							console.error(err);
							reject(err);
							showError("Failed to save", err.message);
						});
					} else {
					*/
					if (message !== "") {
						showSuccess("Save successful", message);
						state.set(["appState", "editor", "showSpinner"], false);
					}
					resolve();
					//}
				})
				.catch((err) => {
					reject(err);
					showError2("Save failed", err);
					// console.log(err.message);
				});

		}).catch((err) => {
			reject(err);
			console.error(err);
			showError2("Save failed", err);
		});
	});

}

const putBatch = function putBatch(bucketName, keyPrefix, files) {
	// console.log("PUT BATCH!");

	return Promise.all(files.map((file) => {
		const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: bucketName } });
		const body = JSON.stringify(file.fileContent);
		// console.log("PUT INVENTORY2");
		return bucket.putObject({ Key: `${file.prefix ? file.prefix : keyPrefix}/${file.fileName}`, ContentType: "application/json", Body: body }).promise();
	}));
};

const putBatchWithKeyPrefix = function putBatchWithKeyPrefix(bucketName, files) {
	return Promise.all(files.map((file) => {
		const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: bucketName } });
		const body = JSON.stringify(file.fileContent);
		// console.log("PUT INVENTORY3");
		return bucket.putObject({ Key: `${file.keyPrefix}/${file.fileName}`, ContentType: "application/json", Body: body }).promise();
	}));
};

/*
export function updateChecklistsAndPushToS3(checklist, newDocument = null, message = "", ignoreContributors = false) {
	const isThirdPartyAuthor = (checklist.hasOwnProperty("identityId") && checklist.identityId !== "" && (isOrganizationAdministrator() || isOrganizationAuthor()));
	if (!checklist.hasOwnProperty("identityId") || checklist.identityId === "" || !checklist.identityId || isThirdPartyAuthor) {
		const documents = state.get(["activities"]);

		const name = state.get(["user", "name"]);
		const username = state.get(["user", "username"]);
		const nickname = state.get(["user", "nickname"]);

		if (!ignoreContributors) {
			if (newDocument === null) {
				if (!checklist.hasOwnProperty("contributors")) {
					const contributors = [];
					contributors.push({ name, username, nickname });
					checklist.contributors = contributors;
				} else if (checklist.contributors.length === 0) {
					checklist.contributors.push({ name, username, nickname });
				} else if (checklist.contributors[checklist.contributors.length - 1].username !== username) {
					checklist.contributors.push({ name, username, nickname });
				}
			}
		}

		const newDocuments = [];

		for (const document of documents) {
			if (!document.hasOwnProperty("newDoc") || !document.newDoc) {
				if (checklist.id === document.id) {
					document.name = checklist.name;
					document.description = checklist.description;
					document.cloned = checklist.cloned;
					document.publisher = checklist.publisher;
					document.genre = checklist.genre;
					document.tags = checklist.tags ? checklist.tags : [];
					document.contributors = checklist.contributors;
					document.heroImage = checklist.heroImage;
					document.checklistId = checklist.checklistId;
					document.driveRootPath = checklist.driveRootPath;
					document.revision = checklist.hasOwnProperty("revision") ? checklist.revision : 1;
					document.externalResources = checklist.hasOwnProperty("externalResources") ? checklist.externalResources : [];
				}
				newDocuments.push(document);
			} else if (document.hasOwnProperty("newDoc") && document.newDoc && checklist.id === document.id) {
				document.newDoc = false;
				document.name = checklist.name;
				document.description = checklist.description;
				document.cloned = checklist.cloned;
				document.publisher = checklist.publisher;
				document.genre = checklist.genre;
				document.tags = checklist.tags ? checklist.tags : [];
				document.contributors = checklist.contributors;
				document.heroImage = checklist.heroImage;
				document.checklistId = checklist.checklistId;
				document.driveRootPath = checklist.driveRootPath;
				document.revision = checklist.hasOwnProperty("revision") ? checklist.revision : 1;
				document.externalResources = checklist.hasOwnProperty("externalResources") ? checklist.externalResources : [];
				newDocuments.unshift(document);
			}
		}
		const keyPrefix = isThirdPartyAuthor ? checklist.identityId : getIdentityId();
		const files = isThirdPartyAuthor ? [
			{
				fileName: `${checklist.id}.json`,
				fileContent: checklist,
				prefix: checklist.identityId
			},
		] : [
				{
					fileName: env.artifacts.inventoryFileName,
					fileContent: newDocuments,
				},
				{
					fileName: `${checklist.id}.json`,
					fileContent: checklist,
				},
			];

		if (newDocument !== null) {
			newDocuments.unshift(newDocument);
		}
		// console.log("S");
		setActivities(newDocuments).then(() => {
			if (isThirdPartyAuthor) {
				saveJsonFilesToS3(env.s3.contentBucket, files, message, utils.isMobile()).then(() => {
					// Relock it ...
					putLock(checklist.id, keyPrefix);
				});
			} else {
				updateSharedDocument(checklist).then(() => {
					saveJsonFilesToS3(env.s3.contentBucket, files, message, utils.isMobile()).then(() => {
						// Relock it ...
						putLock(checklist.id, keyPrefix);
					});

				}).catch(err => {
					showError("Save Failed", "Unable to update shared activity meta data. Reason:" + err);
					state.set(["appState", "editor", "showSpinner"], false);
				});
			}
		}).catch(err => {
			showError("Save Failed", "Failed to update inventory of activities, reason:" + err);
			state.set(["appState", "editor", "showSpinner"], false);
		});
	} else {
		throw new Error("Unable to save activity, the current user doesn't have the appropriate permissions to perform a save.");
	}
}



export function importChecklistFromCsv(checklist) {
	const newDocument = {
		id: checklist.id,
		name: checklist.name,
		description: checklist.description,
		cloned: (checklist.publisher === "self" ? true : true),
		genre: checklist.genre,
		tags: checklist.tags,
		contributors: checklist.hasOwnProperty("contributors") ? checklist.contributors : [{ name: state.get(["user", "name"]), username: state.get(["user", "username"]), nickname: state.get("user", "nickname") }],
		publisher: checklist.publisher,
		store: "",
		productPlaneId: "",
		shareCode: "",
		shareCodeReceived: "",
		version: "1.0",
		visible: true,
		speedType: "KIAS",
	};

	updateChecklistsAndPushToS3(checklist, newDocument, `The activity ${checklist.name} was successfully imported.`);
}

export function importChecklist(checklist) {
	const newDocument = {
		id: checklist.id,
		name: checklist.name,
		description: checklist.description,
		cloned: (checklist.publisher === "self" ? true : true),
		genre: checklist.genre,
		tags: checklist.tags,
		contributors: checklist.hasOwnProperty("contributors") ? checklist.contributors : [{ name: state.get(["user", "name"]), username: state.get(["user", "username"]), nickname: state.get("user", "nickname") }],
		publisher: checklist.publisher,
		store: "",
		productPlaneId: "",
		shareCode: "",
		shareCodeReceived: "",
		version: "1.0",
		visible: true,
		speedType: "KIAS",
	};

	updateChecklistsAndPushToS3(checklist, newDocument, `The activity ${checklist.name} was successfully imported.`);
}

export function setDocumentPrivacy(activity, privacy) {

	refreshCredentials().then(() => {
		const keyPrefix = utils.getKeyPrefix(state.select(["user", "identityId"]).get());

		const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: env.s3.contentBucket, ResponseContentType: "application/json", ResponseCacheControl: "no-cache" } });
		bucket.getObject({ Key: `${keyPrefix}/${activity.id}.json` }, (err, data) => {

			if (err) {
				alert(err, err.stack);
			} else {
				let checklist = JSON.parse(data.Body.toString());
				// If privacy = public then copy
				// If privacy = private then delete
				checklist.privacy = privacy;

				// Need to update documents collection
				activity.privacy = privacy;
				updateActivity(activity);

				let documentsToSend = _.cloneDeep(state.get(["activities"]));
				documentsToSend.shift();

				if (privacy === "public") {
					const files = [
						{
							keyPrefix,
							fileName: env.artifacts.inventoryFileName,
							fileContent: documentsToSend,
						},
						{
							keyPrefix: PUBLIC_KEY_PREFIX,
							fileName: `${checklist.id}.json`,
							fileContent: checklist,
						},
					];

					saveJsonFilesToS3WithKeyPrefix(env.s3.contentBucket, files, "");
				} else if (privacy === "private") {
					// Not consistent...above we do this in a batch
					deleteJsonFileFromS3WithKeyPrefix(env.s3.contentBucket, PUBLIC_KEY_PREFIX, `${activity.id}.json`);
					saveJsonToS3WithKeyPrefix(documentsToSend, env.s3.contentBucket, keyPrefix, env.artifacts.inventoryFileName, "");
				}
			}
		});

	}).catch((err) => {
		console.error(err);
		showError2("Set privacy failed", err);
	});
}

export function setDocumentOrgPrivacy(activity, privacy) {

	refreshCredentials().then(() => {
		const keyPrefix = utils.getKeyPrefix(state.select(["user", "identityId"]).get());

		const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: env.s3.contentBucket, ResponseContentType: "application/json", ResponseCacheControl: "no-cache" } });
		bucket.getObject({ Key: `${keyPrefix}/${activity.id}.json` }, (err, data) => {

			if (err) {
				alert(err, err.stack);
			} else {
				let checklist = JSON.parse(data.Body.toString());
				// If privacy = public then copy
				// If privacy = private then delete
				checklist.orgPrivacy = privacy;

				// Need to update documents collection
				activity.orgPrivacy = privacy;
				updateActivity(activity);

				let documentsToSend = _.cloneDeep(state.get(["activities"]));
				documentsToSend.shift();

				if (privacy === "public") {
					const files = [
						{
							keyPrefix,
							fileName: env.artifacts.inventoryFileName,
							fileContent: documentsToSend,
						},
						{
							keyPrefix: `${state.get(["selectedOrg", "id"])}/${PUBLIC_KEY_PREFIX}`,
							fileName: `${checklist.id}.json`,
							fileContent: checklist,
						},
					];

					saveJsonFilesToS3WithKeyPrefix(env.s3.contentBucket, files, "");
				} else if (privacy === "private") {
					// Not consistent...above we do this in a batch
					deleteJsonFileFromS3WithKeyPrefix(env.s3.contentBucket, `${state.get(["selectedOrg", "id"])}/${PUBLIC_KEY_PREFIX}`, `${activity.id}.json`);
					saveJsonToS3WithKeyPrefix(documentsToSend, env.s3.contentBucket, keyPrefix, env.artifacts.inventoryFileName, "");
				}
			}
		});

	}).catch((err) => {
		console.error(err);
		showError2("Set privacy failed", err);
	});
}

export function toggleSpeedType(document) {
	const documents = state.get(["activities"]);

	const newDocuments = [];

	for (const doc of documents) {
		if (!doc.hasOwnProperty("newDoc") || !doc.newDoc) {
			if (doc.id === document.id) {
				if (doc.speedType.toLowerCase() === "mph") {
					doc.speedType = "KIAS";
				} else {
					doc.speedType = "MPH";
				}
			}
			newDocuments.push(doc);
		}
	}



	// TODO: Can get out of sync without promise
	saveJsonToS3(newDocuments, env.s3.contentBucket, env.artifacts.inventoryFileName).then(() => {
		setActivities(newDocuments);
	}).catch(err => {
		throw err;
	});
}

export function printTemplate(name, data, templateId) {
	state.set(["appState", "documents", "showSpinner"], true);

	const myData = { template: { name: templateId }, data: JSON.stringify(data) };

	jsreport.serverUrl = env.jsreports.url;

	// add custom headers to ajax calls
	jsreport.headers.Authorization = env.jsreports.auth;
	// jsreport.headers['Content-Type'] = "application/json";

	// render through AJAX request and return promise with array buffer response
	jsreport.renderAsync(myData).then((res) => {
		// console.log("Results from jsreports: ", res);

		// open in new window
		//window.open(res.toDataURI());

		//window.location.href = "data:image/gif;base64,R0lGODlhAQABAAAAACw=";
		//window.open("https://www.ambifi.com", "_blank");
		// open download dialog

		//actions.postMessage({ method: "showGoBack" });

		//// console.log(res.toDataURI());

		state.set(["appState", "documents", "showSpinner"], false);

		if (utils.isMobile()) {
			postMessage({ method: "base64Blob", base64: res.toDataURI() });
		} else {
			postMessage({ method: "showGoBack" });
			res.download(name + ".pdf");
		}
	}, (reason) => {
		state.set(["appState", "documents", "showSpinner"], false);

		alert(`Error: ${reason.status}\n${reason.statusText}`);
		// rejection
	});

}

export function print(document, columns = false) {
	refreshCredentials().then(() => {
		const keyPrefix = utils.getKeyPrefix(state.select(["user", "identityId"]).get());

		const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: env.s3.contentBucket, ResponseContentType: "application/json", ResponseCacheControl: "no-cache" } });
		bucket.getObject({ Key: `${keyPrefix}/${document.id}.json` }, (err, data) => {
			if (err) {
				// console.log(err, err.stack);
				alert(`${err}; ${err.stack}`);
			} else {
				let checklist = JSON.parse(data.Body.toString());
				utils.recurseReplaceSpeeds(checklist.children);

				let templateId;

				if (columns) {
					utils.recurseConvertChecklistToMarkdown(checklist.children, true);
					if (utils.isChecklistItems(checklist)) {
						templateId = "ambifi-items-columns";
					} else if (utils.isChecklistSections(checklist)) {
						templateId = "ambifi-sections-columns";
					} else if (utils.isChecklistLists(checklist)) {
						templateId = "ambifi-lists-columns";
					}
				} else {
					utils.recurseConvertChecklistToMarkdown(checklist.children, false);
					if (utils.isChecklistItems(checklist)) {
						if (checklist.publisher.toLowerCase() === "checkmate") {
							templateId = "miracheck-items-checkmate";
						} else {
							templateId = "ambifi-items";
						}
					} else if (utils.isChecklistSections(checklist)) {
						if (checklist.publisher.toLowerCase() === "checkmate") {
							templateId = "miracheck-sections-checkmate";
						} else {
							templateId = "ambifi-sections";
						}
					} else if (utils.isChecklistLists(checklist)) {
						if (checklist.publisher.toLowerCase() === "checkmate") {
							templateId = "miracheck-lists-checkmate";
						} else {
							templateId = "ambifi-lists";
						}
					}
				}

				printTemplate(document.name, checklist, templateId);
			}
		});

	}).catch((err) => {
		console.error(err);
		showError2("Print failed", err);
	});
}

export function printShowMode(document) {
	refreshCredentials().then(() => {
		const keyPrefix = utils.getKeyPrefix(state.select(["user", "identityId"]).get());

		const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: env.s3.contentBucket, ResponseContentType: "application/json", ResponseCacheControl: "no-cache" } });
		bucket.getObject({ Key: `${keyPrefix}/${document.id}.json` }, (err, data) => {
			if (err) {
				// console.log(err, err.stack);
				alert(`${err}; ${err.stack}`);
			} else {
				const checklist = JSON.parse(data.Body.toString());
				utils.recurseReplaceSpeeds(checklist.children);

				let templateId;

				utils.recurseConvertChecklistToMarkdown(checklist.children, true);
				if (utils.isChecklistItems(checklist)) {
					templateId = "ambifi-items-show-mode";
				} else if (utils.isChecklistSections(checklist)) {
					templateId = "ambifi-sections-show-mode";
				} else if (utils.isChecklistLists(checklist)) {
					templateId = "ambifi-lists-show-mode";
				}

				printTemplate(document.name, checklist, templateId);
			}
		});

	}).catch((err) => {
		console.error(err);
		showError2("Print failed", err);
	});
}

export function getExtract(sql = "") {
	refreshCredentials().then(() => {
		let event = {
			orgId: getOrgId(),
			identityId: getIdentityId(),
			csvFilename: "history-extract-" + moment().format() + ".csv"
		};

		if (sql !== "") {
			event.sql = sql;
		}

		let lambda = new AWS.Lambda({ region: "us-east-1", apiVersion: "2015-03-31" });
		let params = {
			FunctionName: env.lambda.extractHistoryCsvFunction,
			InvocationType: "RequestResponse",
			LogType: "None",
			Payload: JSON.stringify(event)
		};

		state.set(["appState", "documents", "showSpinner"], true);
		lambda.invoke(params, function (error, data) {
			if (error) {

				state.set(["appState", "documents", "showSpinner"], false);
				alert(error.message);
			} else {
				const result = data.Payload;

				const newResult = JSON.parse(result);
				// console.log(newResult.outputLocation);
				// console.log(JSON.stringify(result));
				// get s3 document
				const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: env.s3.contentBucket, ResponseContentType: "text/csv", ResponseCacheControl: "no-cache" } });
				bucket.getObject({ Key: newResult.outputFileLocation }, (err, data) => {
					state.set(["appState", "documents", "showSpinner"], false);
					if (err) {
						// console.log(err, err.stack);
						alert(`${err}; ${err.stack}`);
					} else {
						const csv = data.Body;
						//// console.log(csv);

						utils.createBlobCsv2(csv, event.csvFilename);
					}
				});
			}
		});
	}).catch((err) => {
		console.error(err);
		showError2("Extract failed", err);
	});
}
export function exportCsv(document) {
	refreshCredentials().then(() => {
		const keyPrefix = utils.getKeyPrefix(state.select(["user", "identityId"]).get());

		const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: env.s3.contentBucket, ResponseContentType: "application/json", ResponseCacheControl: "no-cache" } });
		bucket.getObject({ Key: `${keyPrefix}/${document.id}.json` }, (err, data) => {
			if (err) {
				// console.log(err, err.stack);
				alert(`${err}; ${err.stack}`);
			} else {
				const checklist = JSON.parse(data.Body.toString());
				const resArr = [["list", "section", "label1", "label2", "labelOnly", "labelOnlyBackgroundColor", "mandatory"]];
				const lastList = "";
				const lastSection = "";

				utils.recurseToFlatArray(checklist.children, lastList, lastSection, resArr);

				const lineArray = [];
				resArr.forEach((infoArray) => {
					const line = infoArray.join(",");
					lineArray.push(line);
				});
				const csvContent = lineArray.join("\n");

				utils.createBlobCsv2(csvContent, `${checklist.name}.csv`);
			}
		});

	}).catch((err) => {
		console.error(err);
		showError2("Export failed", err);
	});
}

export function exportCsvAdvanced(document) {
	refreshCredentials().then(() => {
		const keyPrefix = utils.getKeyPrefix(state.select(["user", "identityId"]).get());

		const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: env.s3.contentBucket, ResponseContentType: "application/json", ResponseCacheControl: "no-cache" } });
		bucket.getObject({ Key: `${keyPrefix}/${document.id}.json` }, (err, data) => {
			if (err) {
				// console.log(err, err.stack);
				alert(`${err}; ${err.stack}`);
			} else {
				const checklist = JSON.parse(data.Body.toString());
				const resArr = [
					[
						"checklistId",
						"checklistName",
						"checklistAudio",
						"checklistPrint",
						"checklistDescription",
						"checklistDontSpeakAudio",
						"checklistTrackLocation",
						"checklistGenre",
						"checklistTags",
						"listId",
						"listName",
						"listAudio",
						"listPrint",
						"listDefaultView",
						"listColor",
						"listIgnoreCompletion",
						"listDontPrint",
						"sectionId",
						"sectionName",
						"sectionAudio",
						"sectionPrint",
						"sectionColor",
						"sectionIconColor",
						"sectionBackgroundColor",
						"sectionBorderColor",
						"sectionIgnoreCompletion",
						"sectionDontPrint",
						"itemId",
						"itemType",
						"itemShowModeTextAlign",
						"itemLabel1",
						"itemLabel2",
						"itemComments",
						"itemCommentsInline",
						"itemMandatory",
						"itemIgnoreCompletion",
						"itemLabelOnly",
						"itemLabelOnlyBackgroundColor",
						"itemLabel1Color",
						"itemLabel1Audio",
						"itemLabel1Print",
						"itemLabel2Color",
						"itemLabel2Audio",
						"itemLabel2Print",

						"textInputPlaceholder",
						"textInputDefaultValue",
						"textInputMaxLength",
						"textInputKeyboardType",
						"textInputKeyboardAutoCapitalize",
						"textInputKeyboardAutoCorrect",
						"textInputKeyboardReturnKeyType",
						"textInputMaskType",
						"textInputCurrencySymbol",
						"textInputCurrencySeparator",
						"textInputNumberOfLines",

						"pickerItemViewType",
						"pickerItemsDatasource",
						"pickerItemPlaceholder",
						"pickerItemDefaultValue",
						"pickerItems",
						"pickerAdvanceOnSelect",
						"pickerLinkOnSelect",
						"pickerLinkActionType",

						"yesNoLinkOnSelect",
						"yesNoLinkActionType",
						"yesNoYesLinkId",
						"yesNoNoLinkId",
						"yesNoNaLinkId",
						"yesNoShowNa",
						"yesNoAdvanceOnSelect",

						"dateTimeType",
						"dateTimeInitialDate",
						"dateTimeMinuteInterval",
						"dateTimeAdvanceOnSelect",

						"imagePickerAddMediaButton",
						"imagePickerUploadTitle",
						"imagePickerCaptureMediaTitle",

						"sketchPadBackgroundColor",
						"sketchPadPenColor",
						"sketchPadPenWidth",

						"itemDontPrint",
						"itemStartTimer",
						"itemStopTimer",

						"itemLinkOnCheck",
						"itemLinkId",
						"itemLinkActionType"
					]
				];
				const lastList = "";
				const lastSection = "";
				utils.recurseToFlatArrayAdvanced(checklist, checklist.children, lastList, lastSection, resArr);

				const lineArray = [];
				resArr.forEach((infoArray) => {
					const line = infoArray.join(",");
					lineArray.push(line);
				});
				const csvContent = lineArray.join("\n");
				utils.createBlobCsv2(csvContent, `${checklist.name}.csv`);
			}
		});
	}).catch((err) => {
		console.error(err);
		showError2("Export failed", err);
	});
}

export function convertImageUrlToBase64(imageUrl) {
	refreshCredentials().then(() => {
		const lambda = new AWS.Lambda({ region: env.aws.defaultRegion, apiVersion: "2015-03-31" });

		const params = {
			FunctionName: "convertImageUrlToBase64",
			InvocationType: "RequestResponse",
			LogType: "None",
			Payload: `{"imageUrl":"${imageUrl}"}`,
		};

		lambda.invoke(params, (error, data) => {
			if (error) {
				alert(error);
			} else {
				// console.log(data.Payload);
			}
		});

	}).catch((err) => {
		console.error(err);
		showError2("Convert failed", err);
	});
}
*/
function showErrorNoDetail(title, err) {
	if (err === null) {
		showError(title, "Unknown error.");
	} else if (err.code === "NetworkingError") {
		showError(title, "Network error. Please check connectivity and try again.");
	} else {
		showError(title, err.message);
	}
}


/**
 * NEW FUNCTIONS added as part of the larger refactor, need to focus more on cohesion to ensure these modules don't grow into confusing monoliths.
 */


export function getActivity(activityId, prefix = getIdentityId()) {
	return getObject(env.s3.contentBucket, `${prefix}/${activityId}.json`);
}

export function getActivityIfExists(activityId, prefix = getIdentityId()) {
	return new Promise((resolve, reject) => {
		refreshCredentials().then(() => {
			objectExists(env.s3.contentBucket, `${prefix}/${activityId}.json`).then(exists => {
				if (exists) {
					getObject(env.s3.contentBucket, `${prefix}/${activityId}.json`).then(content => {
						resolve(content);
					}).catch(err => {
						reject(err);
					});
				} else {
					resolve();
				}
			}).catch(err => {
				reject(err);
			});
		}).catch(err => {
			reject(err);
		});
	});
}

export function activityExists(activityId, prefix = getIdentityId()) {
	return new Promise((resolve, reject) => {
		refreshCredentials().then(() => {
			objectExists(env.s3.contentBucket, `${prefix}/${activityId}.json`).then(exists => {
				resolve(exists);
			}).catch(err => {
				reject(err);
			});
		}).catch(err => {
			reject(err);
		});
	});
}

export function getObject(bucketName, key, skipParse = false) {
	return new Promise((resolve, reject) => {
		refreshCredentials().then(() => {
			// console.log("About to get Object", bucketName, key);
			const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: bucketName, ResponseContentType: "application/json", ResponseCacheControl: "no-cache" } });
			bucket.getObject({ Key: key }, (err, data) => {
				if (err) {
					reject(err);
				} else {
					// // console.log(data, data.Body.toString());
					if (skipParse) {
						resolve(data.Body);
					} else {
						resolve(JSON.parse(_.trim(data.Body.toString())));
					}
				}
			});
		}).catch(err => {
			reject(err);
		});
	});
}
/*
export function getInventory(prefix = getIdentityId()) {
	return new Promise((resolve, reject) => {
		refreshCredentials().then(() => {
			const Key = `${prefix}/${INVENTORY_FILE_NAME}`;
			const Bucket = env.s3.contentBucket;

			objectExists(Bucket, Key).then((res) => {
				if (res) {
					const bucket = new AWS.S3({ useDualStack: true, params: { Bucket, ResponseContentType: "application/json", ResponseCacheControl: "no-cache" } });
					bucket.getObject({ Key }, (err, data) => {
						if (err) {
							reject(err);
						} else {
							resolve(JSON.parse(data.Body.toString()));
						}
					});
				} else {
					// Doesn't exist yet!
					uploadObject([], Bucket, Key).then(() => {
						resolve([]);
					}).catch(err => {
						reject(err);
					});
				}
			}).catch(err => {
				reject(err);
			});
		}).catch(err => {
			reject(err);
		});
	});
}


export function getTimerTemplates(prefix = getIdentityId()) {
	return new Promise(async (resolve, reject) => {
		try {
			const s3 = new AWS.S3({ useDualStack: true });
			const timerTemplatesData = await s3.getObject({ Bucket: env.s3.contentBucket, Key: prefix + "/" + TIMER_TEMPLATES_FILE_NAME }).promise();
			const newTimerTemplates = JSON.parse(timerTemplatesData.Body.toString());

			resolve(newTimerTemplates);
			// If exists then set otherwise set a template of timers
		} catch (err) {
			if (err.statusCode === 404) {
				await putJsonFileToS3(env.s3.contentBucket, "timerTemplates.json", timerTemplates);
				resolve(timerTemplates);
			} else {
				reject(err);
			}
		}
	});
}
*/

/**
 * This function will filter out all non essential properties from shared/external artifacts.
 * There are only a certain amount of properties that can remain in the users inventory.
 * @param {*} activities 
 */
/*
function filterExternalActivityProperties(activities) {
	const result = [];

	activities.forEach(activity => {
		if (activity.hasOwnProperty("identityId") && !_.isEmpty(activity.identityId)) {
			result.push(_.pick(activity, INVENTORY_EXTERNAL_CONTENT_PERSISTENT_PROPS));
		} else {
			result.push(activity);
		}
	});

	return result;
}

export function putInventory(inventory, prefix = getIdentityId()) {

	// Make sure that when this is put that blank entries are removed
	const _inventory = _.filter(inventory, (o) => !o.newDoc);

	return uploadObject(filterExternalActivityProperties(_inventory), env.s3.contentBucket, `${prefix}/${INVENTORY_FILE_NAME}`);
}
*/
export function copyObject(sourceBucket, sourceKey, destinationBucket, destinationKey) {
	return new Promise((resolve, reject) => {
		let params = {
			CopySource: `/${sourceBucket}/${sourceKey}`,
			Key: destinationKey
		};
		const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: destinationBucket } });
		bucket.copyObject(params, function (err, data) {
			if (err) {
				reject(err);
			} else {
				resolve(data);
			}
		});
	});
}

export function moveObject(sourceBucket, sourceKey, destinationBucket, destinationKey) {
	return new Promise((resolve, reject) => {
		copyObject(sourceBucket, sourceKey, destinationBucket, destinationKey).then(() => {
			deleteObject(sourceBucket, sourceKey).then(() => {
				resolve();
			}).catch(err => {
				reject(err);
			});
		}).catch(err => {
			reject(err);
		});
	});
}

export function uploadObject(content, bucketName, key) {
	return new Promise((resolve, reject) => {
		refreshCredentials().then(() => {
			const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: bucketName } });
			const params = { Key: key, ContentType: "application/json", Body: !_.isString(content) ? JSON.stringify(content) : content };
			bucket.upload(params, (err) => {
				if (err) {
					reject(err);
				} else {
					resolve();
				}
			});
		}).catch(err => {
			reject(err);
		});
	});
}

export function deleteObject(bucketName, key) {
	return new Promise((resolve, reject) => {
		refreshCredentials().then(() => {
			const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: bucketName } });
			bucket.deleteObject({ Key: key }, err => {
				if (err) {
					reject(err);
				} else {
					resolve();
				}
			});
		}).catch((err) => {
			reject(err);
		});
	});

}
export function deleteObjects(bucketName, objects) {
	return new Promise((resolve, reject) => {
		refreshCredentials().then(() => {
			const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: bucketName } });
			bucket.deleteObjects({ Delete: { Objects: objects } }, err => {
				if (err) {
					reject(err);
				} else {
					resolve();
				}
			});
		}).catch((err) => {
			reject(err);
		});
	});

}
export function objectExists(bucketName, key) {

	return new Promise((resolve, reject) => {
		refreshCredentials().then(() => {
			const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: bucketName } });
			bucket.headObject({ Key: key }, function (err) {
				if (err && err.code === "NotFound") {
					resolve(false);
				} else if (err) {
					reject(err);
				} else {
					resolve(true);
				}
			});
		}).catch((err) => {
			reject(err);
		});
	});
}

export function objectExists2(bucketName, key) { // eslint-disable-line
	return new Promise((resolve) => {
		resolve(true);
	});
}


export function listAllObjects(bucketName, prefix) {
	return new Promise((resolve, reject) => {
		refreshCredentials().then(() => {
			recursiveListObjects(bucketName, prefix, (err, data) => {
				if (err) {
					reject(err);
				} else {
					resolve(data);
				}
			});
		}).catch((err) => {
			reject(err);
		});
	});
}

function recursiveListObjects(bucketName, prefix = null, cb = () => { }, marker = null, files = []) {
	const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: bucketName } });
	const params = {
		Bucket: bucketName
	};

	// are we paging from a specific point?
	if (marker) {
		params.Marker = marker;
	}

	if (prefix) {
		params.Prefix = prefix;
	}

	bucket.listObjects(params, function (err, data) {
		if (err) {
			return cb(err);
		}

		// concat the list of files into our collection
		files = files.concat(data.Contents);

		// are we paging?
		if (data.IsTruncated) {
			let length = data.Contents.length;
			let marker = data.Contents[length - 1].Key;
			// recursion!
			recursiveListObjects(bucketName, prefix, cb, marker, files);
		} else {
			cb(undefined, files);
		}

	});
}

export function batchGetActivities(activities) {
	return new Promise((resolve, reject) => {
		Promise.all(activities.map((activity) => {

			let keyPrefix = getIdentityId();
			if (activity.hasOwnProperty("identityId")) {
				keyPrefix = activity.identityId;
			}

			return getActivityIfExists(activity.id, keyPrefix);
		})).then(results => {
			resolve(_.filter(results, (o) => { return !_.isUndefined(o) && !_.isNull(o); }));
		}).catch(err => {
			reject(err);
		});
	});
}

export function getObjectTags(bucketName, key) {
	return new Promise((resolve, reject) => {
		refreshCredentials().then(() => {
			const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: bucketName } });
			bucket.getObjectTagging({ Key: key }, (err, data) => {
				if (err) {
					reject(err);
				} else {
					resolve(data.TagSet);
				}
			});
		}).catch((err) => {
			reject(err);
		});
	});
}

export function getObjectTag(bucketName, key, tagName) {
	return new Promise((resolve, reject) => {
		const multipleTagNames = _.isArray(tagName);
		getObjectTags(bucketName, key).then(tags => {
			let result = null;
			tags.forEach(tag => {
				if (!multipleTagNames && tag.Key === tagName) {
					result = tag.Value;
				} else if (multipleTagNames && _.indexOf(tagName, tag.Key) !== -1) {
					if (!result) {
						result = {};
					}
					result[tag.Key] = tag.Value;
				}
			});
			resolve(result);
		}).catch(err => {
			reject(err);
		});
	});
}

export function getActivityTag(activityId, tagName, prefix = getIdentityId()) {
	return getObjectTag(env.s3.contentBucket, `${prefix}/${activityId}.json`, tagName);
}

export function putObjectTags(bucketName, key, tags) {
	return new Promise((resolve, reject) => {
		refreshCredentials().then(() => {
			const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: bucketName } });
			bucket.putObjectTagging({ Key: key, Tagging: { TagSet: tags } }, (err, data) => {
				if (err) {
					reject(err);
				} else {
					resolve(data);
				}
			});
		}).catch((err) => {
			reject(err);
		});
	});
}
export function putActivityTag(activityId, tagName, tagValue, prefix = getIdentityId()) {
	return putActivityTags(activityId, { [tagName]: tagValue }, prefix);
}

/**
 * 
 * @param {*} activityId activity that shall receive the tags (will be added to existing tags)
 * @param {Object} tagsObj key/value map
 * @param {*} prefix 
 */
export function putActivityTags(activityId, tags, prefix = getIdentityId()) {
	return new Promise((resolve, reject) => {
		const BucketName = env.s3.contentBucket;
		const Key = `${prefix}/${activityId}.json`;
		getObjectTags(BucketName, Key).then(existingTags => {
			const existingTagsMap = existingTags && existingTags.length > 0 ? utils.arrayToMap(existingTags, "Key") : {};
			_.keys(tags).forEach(key => {
				existingTagsMap[key] = tags[key];
			});
			// console.log(existingTagsMap);
			const newTags = _.keys(existingTagsMap).map(Key => {
				return {
					Key,
					Value: existingTagsMap[Key]
				};
			});
			// console.log(newTags);
			putObjectTags(BucketName, Key, newTags).then(res => {
				resolve(res);
			}).catch(err => {
				reject(err);
			});
		});
	});
}


export function loadActivityInstanceFromS3(bucketName, fileName) {
	return new Promise((resolve, reject) => {
		refreshCredentials().then(() => {
			const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: bucketName, ResponseContentType: "application/json", ResponseCacheControl: "no-cache" } });
			bucket.getObject({ Key: `${fileName}` }, (err, data) => {
				if (err) {
					console.error(err);
					showError("Unable to get activity", err);
					reject(err);
				} else {
					// Set previewChecklist
					let jsonChecklist = JSON.parse(data.Body.toString());
					// Should convert to make sure has at least one list and one section and set proper type
					jsonChecklist = utils.normalizeActivity(jsonChecklist);
					resolve(jsonChecklist);
				}
			});
		}).catch((err) => {
			console.error(err);
			showError2("Unable to load activity", err);
			reject(err);
		});
	});

}

export async function loadTimerTemplatesFromS3() {
	let timerTemplates = await getJsonFileFromS3(env.s3.contentBucket, "timerTemplates.json");
	return timerTemplates;
}